import React, { useEffect, useState } from "react";
import moment from "moment";
import InputMask from "react-input-mask";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";

import {
  LoadingSpinner,
  convertUTCToLocalTime,
  isUrdu,
} from "../../../constants/const";
import { GetLanguageString, NoResult } from "../../helper/Components";
import { addMember } from "../ApiMember";

const getFirstValue = (record, fields) => {
  for (const field of fields) {
    if (record?.[field] !== undefined && record?.[field] !== null && record?.[field] !== "") {
      return record[field];
    }
  }

  return "-";
};

const formatDate = (date) => {
  if (!date || date === "-") return "-";

  return moment(convertUTCToLocalTime(date)).format("DD/MM/yyyy");
};

const calculateAge = (date) => {
  if (!date || date === "-") return "-";

  const birthDate = moment(convertUTCToLocalTime(date));
  if (!birthDate.isValid()) return "-";

  return moment().diff(birthDate, "years");
};

const formatCnic = (cnic) => {
  if (!cnic || cnic === "-") return "";

  const rawCnic = cnic.toString().replace(/-/g, "");
  if (rawCnic.length !== 13) return cnic;

  return `${rawCnic.slice(0, 5)}-${rawCnic.slice(5, 12)}-${rawCnic.slice(12)}`;
};

const getInputClassName = (value) => (isUrdu(value) ? "ur" : "");

const DetailField = ({ label, value, name, md = "3", type = "text", rows }) => (
  <Col md={md}>
    <FormGroup>
      <Label className="col-form-label">{label}</Label>
      <Input
        className={getInputClassName(value)}
        type={type}
        name={name}
        value={value}
        rows={rows}
        disabled
      />
    </FormGroup>
  </Col>
);

const NonRafiqUserDetails = ({ editValue }) => {
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    if (!editValue) return;

    setLoading(true);
    addMember()
      .GetNonRafiqUserDetails(editValue)
      .then((res) => {
        setUserDetails(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [editValue]);

  const responsibilityRecord =
    getFirstValue(userDetails, ["Responsibility", "responsibility"]) || {};
  const responsibility = getFirstValue(responsibilityRecord, [
    "Label",
    "label",
  ]);
  const fallbackResponsibility = getFirstValue(userDetails, [
    "ResponsibilityName",
    "responsibilityName",
    "responsibilityLabel",
  ]);
  const responsibilityText =
    responsibility !== "-" ? responsibility : fallbackResponsibility;

  const rows = [
    {
      label: <GetLanguageString props="common_name" />,
      value: getFirstValue(userDetails, ["FullName", "fullName", "name"]),
      name: "fullName",
    },
    {
      label: <GetLanguageString props="member_fathers_name" />,
      value: getFirstValue(userDetails, ["FatherName", "fatherName"]),
      name: "fatherName",
    },
    {
      label: <GetLanguageString props="member_date_of_birth" />,
      value: formatDate(getFirstValue(userDetails, ["BirthDate", "birthDate"])),
      name: "birthDate",
    },
    {
      label: <GetLanguageString props="member_registration_date" />,
      value: formatDate(
        getFirstValue(userDetails, ["JoiningDate", "joiningDate"])
      ),
      name: "joiningDate",
    },
    {
      label: <GetLanguageString props="member_age" />,
      value: calculateAge(getFirstValue(userDetails, ["BirthDate", "birthDate"])),
      name: "age",
    },
    {
      label: <GetLanguageString props="member_cnic" />,
      value: formatCnic(getFirstValue(userDetails, ["CNIC", "cnic"])),
      name: "cnic",
    },
    {
      label: <GetLanguageString props="member_address" />,
      value: getFirstValue(userDetails, [
        "Address",
        "currentAddress",
        "address",
      ]),
      name: "address",
      md: "6",
    },
    {
      label: <GetLanguageString props="member_contact" />,
      value: getFirstValue(userDetails, [
        "contactNo",
      ]),
      name: "contactNo",
    },
    {
      label: <GetLanguageString props="member_responsibility" />,
      value: responsibilityText,
      name: "responsibility",
    },
    {
      label: (
        <GetLanguageString props="member_member_detail_common_responsibility_date" />
      ),
      value: formatDate(
        getFirstValue(userDetails, ["ResponsibilityDate", "responsibilityDate"])
      ),
      name: "responsibilityDate",
    },
  ];

  return (
    <div role="tabpanel" id="userDetails" className="tab-pane active">
      <div className="panel-body">
        {loading ? (
          LoadingSpinner()
        ) : userDetails ? (
          <Row>
            {rows.map((row) =>
              row.name === "cnic" ? (
                <Col md="3" key={row.name}>
                  <FormGroup>
                    <Label className="col-form-label">{row.label}</Label>
                    <InputMask
                      mask="99999-9999999-9"
                      value={row.value}
                      name={row.name}
                      maskChar=""
                      disabled
                    >
                      {(inputProps) => (
                        <Input {...inputProps} type="text" disabled />
                      )}
                    </InputMask>
                  </FormGroup>
                </Col>
              ) : (
                <DetailField
                  key={row.name}
                  label={row.label}
                  value={row.value}
                  name={row.name}
                  md={row.md}
                  type={row.type}
                  rows={row.rows}
                />
              )
            )}
          </Row>
        ) : (
          <NoResult />
        )}
      </div>
    </div>
  );
};

export default NonRafiqUserDetails;
